import React from 'react'
import { RouteProps } from '../../routes/AppRouter'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'
import { Box } from '@mui/material'
import logoCareme from '../../assets/caremePlusLogo.svg'
import style from '../layout/Main.module.css'
import { Notifications as NotificationsComponent } from '../../features/notifications/Notifications'

export function Notifications(props: RouteProps) {
  const { setTitle } = useTitleHeaderContext()
  const title = props.title || 'Notificaciones'

  React.useEffect(() => {
    setTitle(title)
  }, [title, setTitle])

  return (
    <>
      <NotificationsComponent />
      <Box display={'flex'} justifyContent={'flex-end'}>
        <img src={logoCareme} alt="Logo Careme" className={style.logo} />
      </Box>
    </>
  )
}
